<template lang="pug">
.main-item(v-if="[40].includes(sportsType)")
  .collapse.show(
    :id="'league-' + source.id"
    :aria-labelledby="source.id"
  )
    .card-body.p-0
      template(v-if="isChild2() && [40].includes(sportsType)" v-for="(val, key) in sport4dTab")
        .match(:class="[(source.marketId == 3) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
          .normal-title {{ val }}
          swiper(ref="sw" :options="swiperOptions" @slideChange="handleSlideChange")
            template(v-for="(sitem, skey) in child2Ids")
              template(v-if="[40].includes(sportsType) && isDataEmptyEsportMore(hdpou(sitem[0]))")
                swiper-slide.match-marketgroup-content(:class="[(source.marketId == 3) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
                  .match-bet-area-group.flex-grow-2
                    ouoeItem(:details="hdpou(sitem[0])" :oddsType="oddsType" :i="0")
                .swiper-pagination(slot="pagination")
div(v-else)
  template(v-if="isChild2() && [20].includes(sportsType) && index == 0" v-for="(val, key, index) in esportTab")
    .match(:class="[(source.marketId == 3) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
      .normal-title {{ val }}
      swiper(ref="sw" :options="swiperEsportsOptions" @slideChange="handleSlideChange")
        template(v-for="(sitem, skey) in child2Ids" v-if="sitem[2] == key")
          template(v-if="[20].includes(sportsType) && isDataEmptyEsportMore(hdpou(sitem[0]))")
            swiper-slide.match-marketgroup-content(:class="[(source.marketId == 3) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
              hdpouoemlItemMore(:details="hdpou(sitem[0])" :oddsType="oddsType" :i="0")
            .swiper-pagination(slot="pagination")
</template>

<script>
import config from "@/config";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";
import ouoeItem from "@/components/mobile/main/xitem/ouoeItem";
import hdpouoemlItemMore from "@/components/mobile/main/xitem/hdpouoemlItemMore";
import mlItemMore from "@/components/mobile/main/xitem/mlItemMore";
import hdpItemMore from "@/components/mobile/main/xitem/hdpItemMore";
import ouItemMore from "@/components/mobile/main/xitem/ouItemMore";
import oeItemMore from "@/components/mobile/main/xitem/oeItemMore";

export default {
  components: {
    ouoeItem,
    hdpouoemlItemMore,
    mlItemMore,
    hdpItemMore,
    ouItemMore,
    oeItemMore
  },
  mixins: [mixinHDPOUOdds],
  data() {
    return {
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      swiperEsportsOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.sw ? this.$refs.sw.$swiper : 0;
    },
    child1Ids() {
      if([40].includes(this.sportsType)) {
        if(this.source && this.source.matchList && this.source.matchList[0] && this.source.matchList[0].details) {
          return this.source.matchList[0].details.child1;
        }
      } else {
        if(this.source && this.source.details) {
          return this.source.details.child1;
        }
      }
      return [];
    },
    child2Ids() {
      if([40].includes(this.sportsType)) {
        if(this.source && this.source.matchList && this.source.matchList[0] && this.source.matchList[0].details) {
          return this.source.matchList[0].details.child2;
        }
      } else {
        if(this.source && this.source.details) {
          return this.source.details.child2;
        }
      }
      return [];
    },
    esportTab() {
      var sportTab = {};

      if (this.child1Ids) {
        this.child2Ids.forEach((v, k) => {
          if (config.esportsTab.hasOwnProperty(v[2]) && this.isDataEmptyEsportMore(this.hdpou(v[0]))) {
            sportTab[v[2]] = config.esportsTab[v[2]];
          }
        });
      }
      return sportTab;
    },
    sport4dTab() {
      var sportTab = {};
      if (this.child1Ids) {
        this.child2Ids.forEach((v, k) => {
          if (config.sports4dTab.hasOwnProperty(v[2]) && this.isDataEmptyEsportMore(this.hdpou(v[0]))) {
            sportTab[v[2]] = config.sports4dTab[v[2]];
          }
        });
      }
      return sportTab;
    }
  },
  mounted() {
    // this.activeIndex = this.swiper.activeIndex;
  },
  methods: {
    isChild1() {
      return this.child1Ids ? this.child1Ids.length > 0 : false;
    },
    isChild2() {
      return this.child2Ids ? this.child2Ids.length > 0 : false;
    },
    handleSlideChange() {
      // this.activeIndex = this.swiper.activeIndex;
    },
    isDataEmptyEsportMore(details) {
      var hdp = details["hdp"] != null && details["hdp"][0] != null;
      var ou = details["ou"] != null && details["ou"][0] != null;
      var ml = details["ml"] != null && details["ml"][0] != null;
      var oe = details["oe"] != null && details["oe"][0] != null;
      return hdp || ou || oe || ml;
    },
    league() {
      return this.$store.getters.data.league;
    },
    head() {
      return this.$store.getters.data.head;
    },
    match() {
      return this.$store.getters.data.match;
    },
    odds() {
      if (this.$store.getters.data.hasOwnProperty("odds")) {
        if (this.$store.getters.data.odds[this.layoutIndex] != null) {
          return this.$store.getters.data.odds[this.layoutIndex];
        } else {
          return {};
        }
      }
      return {};
    },
    mmo() {
      if (this.$store.getters.data.hasOwnProperty("mmo")) {
        if (this.$store.getters.data.mmo[this.layoutIndex] != null) {
          return this.$store.getters.data.mmo[this.layoutIndex];
        } else {
          return {};
        }
      }
      return {};
    },
    hdpouMMO(e) {
      var odds = this.mmo();
      var r = {};
      r["tn"] = 0;
      r["team"] = null;
      r["oxtn"] = 0;
      r["more"] = 0;

      if (odds != null) {
        if (odds.hasOwnProperty("hdp")) {
          if (odds["hdp"][e] != null) {
            r["hdp"] = odds["hdp"][e].filter((v, i, r) => {
              return v[4] == "HDP";
            });
            r["hdph"] = odds["hdp"][e].filter((v, i, r) => {
              return v[4] == "HDPH";
            });
            if (r["hdp"] ? r["hdp"].length : 0 > r["tn"]) {
              r["tn"] = r["hdp"].length;
              if (r["hdp"][0][8] != null && r["hdp"][0][8] != "0") {
                r["team"] = r["hdp"][0][7];
              } else {
                r["team"] = 2;
              }
            } else {
              r["hdp"] = null;
            }
            if (r["hdph"] ? r["hdph"].length : 0 > r["tn"]) {
              if (r["tn"] < r["hdph"].length) {
                r["tn"] = r["hdph"].length;
              }
              if (r["team"] == null) {
                if (r["hdph"][0][8] != null && r["hdph"][0][8] != "0") {
                  r["team"] = r["hdph"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["hdph"] = null;
            }
          }
        }

        if (odds.hasOwnProperty("ou")) {
          if (odds["ou"][e]) {
            r["ou"] = odds["ou"][e].filter((v, i, r) => {
              return v[4] == "OU";
            });
            r["ouh"] = odds["ou"][e].filter((v, i, r) => {
              return v[4] == "OUH";
            });
            if (r["ou"] ? r["ou"].length : 0 > r["tn"]) {
              if (r["tn"] < r["ou"].length) {
                r["tn"] = r["ou"].length;
              }
              if (r["team"] == null) {
                if (r["ou"][0][8] != null && r["ou"][0][8] != "0") {
                  r["team"] = r["ou"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["ou"] = null;
            }
            if (r["ouh"] ? r["ouh"].length : 0 > r["tn"]) {
              if (r["tn"] < r["ouh"].length) {
                r["tn"] = r["ouh"].length;
              }
              if (r["team"] == null) {
                if (r["ouh"][0][8] != null && r["ouh"][0][8] != "0") {
                  r["team"] = r["ouh"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["ouh"] = null;
            }
          }
        }
      }
      return r;
    },
    hdpou(e) {
      var odds = this.odds();
      var r = {};
      r["tn"] = 0;
      r["team"] = null;
      r["oxtn"] = 0;
      r["more"] = 0;

      r["mmo"] = {};

      if (odds != null) {
        if (odds.hasOwnProperty("hdp")) {
          if (odds["hdp"][e] != null) {
            r["hdp"] = odds["hdp"][e].filter((v, i, r) => {
              return v[4] == "HDP";
            });
            r["hdph"] = odds["hdp"][e].filter((v, i, r) => {
              return v[4] == "HDPH";
            });
            if (r["hdp"] ? r["hdp"].length : 0 > r["tn"]) {
              r["tn"] = r["hdp"].length;
              if (r["hdp"][0][8] != null && r["hdp"][0][8] != "0") {
                r["team"] = r["hdp"][0][7];
              } else {
                r["team"] = 2;
              }
            } else {
              r["hdp"] = null;
            }
            if (r["hdph"] ? r["hdph"].length : 0 > r["tn"]) {
              if (r["tn"] < r["hdph"].length) {
                r["tn"] = r["hdph"].length;
              }
              if (r["team"] == null) {
                if (r["hdph"][0][8] != null && r["hdph"][0][8] != "0") {
                  r["team"] = r["hdph"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["hdph"] = null;
            }
          }
        }

        if (odds.hasOwnProperty("ou")) {
          if (odds["ou"][e]) {
            r["ou"] = odds["ou"][e].filter((v, i, r) => {
              return v[4] == "OU";
            });
            r["ouh"] = odds["ou"][e].filter((v, i, r) => {
              return v[4] == "OUH";
            });
            if (r["ou"] ? r["ou"].length : 0 > r["tn"]) {
              if (r["tn"] < r["ou"].length) {
                r["tn"] = r["ou"].length;
              }
              if (r["team"] == null) {
                if (r["ou"][0][8] != null && r["ou"][0][8] != "0") {
                  r["team"] = r["ou"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["ou"] = null;
            }
            if (r["ouh"] ? r["ouh"].length : 0 > r["tn"]) {
              if (r["tn"] < r["ouh"].length) {
                r["tn"] = r["ouh"].length;
              }
              if (r["team"] == null) {
                if (r["ouh"][0][8] != null && r["ouh"][0][8] != "0") {
                  r["team"] = r["ouh"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["ouh"] = null;
            }
          }
        }

        if (odds.hasOwnProperty("oxt")) {
          if (odds["oxt"][e]) {
            r["oxt"] = odds["oxt"][e].filter((v, i, r) => {
              return v[4] == "1X2";
            });
            r["oxth"] = odds["oxt"][e].filter((v, i, r) => {
              return v[4] == "1X2H";
            });
            if (r["oxt"] ? r["oxt"].length : 0 > r["tn"]) {
              if (r["tn"] < r["oxt"].length) {
                r["tn"] = r["oxt"].length;
              }
              r["oxtn"] = 1;
            } else {
              r["oxt"] = null;
            }
            if (r["oxth"] ? r["oxth"].length : 0 > r["tn"]) {
              if (r["tn"] < r["oxth"].length) {
                r["tn"] = r["oxth"].length;
              }
              r["oxtn"] = 1;
            } else {
              r["oxth"] = null;
            }
          }
        }

        if (odds.hasOwnProperty("oe")) {
          if (odds["oe"][e]) {
            r["oe"] = odds["oe"][e].filter((v, i, r) => {
              return v[4] == "OE";
            });
            r["oeh"] = odds["oe"][e].filter((v, i, r) => {
              return v[4] == "OEH";
            });
            if (r["oe"] ? r["oe"].length : 0 > r["tn"]) {
              if (r["tn"] < r["oe"].length) {
                r["tn"] = r["oe"].length;
              }
              r["oen"] = 1;
            } else {
              r["oe"] = null;
            }
            if (r["oeh"] ? r["oeh"].length : 0 > r["tn"]) {
              if (r["tn"] < r["oeh"].length) {
                r["tn"] = r["oeh"].length;
              }
              r["oehn"] = 1;
            } else {
              r["oeh"] = null;
            }
          }
        }

        if (odds.hasOwnProperty("ml")) {
          if (odds["ml"][e]) {
            r["ml"] = odds["ml"][e].filter((v, i, r) => {
              return v[4] == "ML";
            });
            r["mlh"] = odds["ml"][e].filter((v, i, r) => {
              return v[4] == "MLH";
            });
            if (r["ml"] ? r["ml"].length : 0 > r["tn"]) {
              if (r["tn"] < r["ml"].length) {
                r["tn"] = r["ml"].length;
              }
              r["mln"] = 1;
            } else {
              r["ml"] = null;
            }
            if (r["mlh"] ? r["mlh"].length : 0 > r["tn"]) {
              if (r["tn"] < r["mlh"].length) {
                r["tn"] = r["mlh"].length;
              }
              r["mlhn"] = 1;
            } else {
              r["mlh"] = null;
            }
          }
        }

        var head = this.head();
        var match = this.match();
        if (head[e] == undefined) {
          r["more"] = 0;
        } else {
          r["head"] = head[e][0];
          r["match"] = match[e];
          if (r["head"] != null) {
            r["more"] = head[e][0][7];
          }
          if (r["match"] != null) {
            r["league"] = this.league()[r["match"][1]][4];
          }
        }
      }

      if (this.mmoMode) {
        r["mmo"] = this.hdpouMMO(e);
      }

      this.result = null;
      this.result = r;
      return r;
    },
  }
};
</script>